import request from '@/utils/request'

export default {
  getEvent (eventId, params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/events/${eventId}`,
      method: 'get',
      params
    })
  },
  getWebEvent (eventId, params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/web/events/${eventId}`,
      method: 'get',
      params
    })
  }
}
